import React, { useContext, useState, useEffect } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../common/ModelSave";
import { CancelButton, SaveButton } from "../common/Button";
import {
  Row,
  Col,
  Form,
  Modal,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../utils/context";
import JoditEditor from "jodit-react";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageValidation } from "../../utils/common";
import { ValidationImage } from "../../utils/api";
import { getLatLong, getpincodeLatLong } from "../../utils/apis/master/Master";

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, getDimension } = useContext(Context);

  const [latLong, setLatLong] = useState("");

  console.log(latLong, "latLong");



  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    trigger,
    setError,
    clearErrors,
  } = useForm();
  const imageFile = watch("image");

  const {
    fields: dayFields,
    append: appendDay,
    remove: removeDay,
  } = useFieldArray({
    control,
    name: "packages_day",
  });



  const [quantityError, setQuantityError] = useState("");

  useEffect(() => {
    register("packages_day", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setQuantityError(isValid ? "" : "At least one Package is required");
        return isValid;
      },
    });
  }, [register]);



  const descriptionValue = watch("description");
  useEffect(() => {
    register("description", {
      required: "Description is required.",
    });
  }, [register]);

  const featuresAndAminitiesValue = watch("inclusion");
  useEffect(() => {
    register("inclusion", {
      required: "Inclusion is required.",
    });
  }, [register]);

  const termsAndConditionValue = watch("exclusion");
  useEffect(() => {
    register("exclusion", {
      required: "Exclusion is required.",
    });
  }, [register]);

  const note_and_disclaimers = watch("note_and_disclaimers");
  useEffect(() => {
    register("note_and_disclaimers", {
      required: " Note And Disclaimers is required.",
    });
  }, [register]);


  const onSubmit = async (data) => {
    console.log(data, 'data');

    try {
      const DataToSend = new FormData();
      DataToSend.append("name", data?.name);
      DataToSend.append("location", data?.location);
      DataToSend.append("days", data?.days);
      DataToSend.append("exclusion", data?.exclusion);
      DataToSend.append("inclusion", data?.inclusion);
      DataToSend.append("description", data?.description);
      DataToSend.append("note_and_disclaimers", data?.note_and_disclaimers);
      if (data?.image && data.image.length > 0) {
        DataToSend.append("image", data.image[0]);
      }
      // Append project
      const project = [];
      data.packages_day.forEach((day, index) => {
        const projectData = {
          name: day.name,
          description: day.description,

        };
        project.push(projectData);
      });
      DataToSend.append("packages_day", JSON.stringify(project));
      const response = await postData(`/packages`, DataToSend);
      console.log("response", response);
      console.log("data to send", DataToSend);
      if (response?.success) {
        await props.setShowModal({
          code: response.code,
          message: response.message,
        });
        props.handleClose();
      } else {
        await props.setShowModal({
          code: response.code,
          message: response.message,
        });
      }
      setTimeout(() => {
        props.setShowModal({ code: 0, message: response.message });
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  };

  console.log(getValues(), "getvaluess");
  console.log(errors, "eeeeeeeeeeeeeeeee");


  return (
    <>
      <div className="prodcuttttt">
        <Offcanvas
          show={props.show}
          style={{ width: "80%" }}
          placement={"end"}
          onHide={props.handleClose}
          className="prodcuttttt-offcanvas"
        >
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Add Employee</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5  rounded">
              <Card.Body>
                <Card.Title>Add Package</Card.Title>
                <hr />
                <Container>
                  <Form
                    // onSubmit={() => handleSubmit(onSubmit)}
                    role="form"
                  // className="stateclass"
                  >
                    <Row>


                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Package Name</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control

                                  type="text"
                                  name="name"
                                  placeholder="Package Name .."
                                  className={classNames("", {
                                    "is-invalid": errors?.name,
                                  })}
                                  {...register("name", {
                                    required: "Package Name is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.name && (
                                <span className="text-danger">
                                  {errors.name.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Location</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control

                                  type="text"
                                  name="addlocationress"
                                  placeholder="location .."
                                  className={classNames("", {
                                    "is-invalid": errors?.location,
                                  })}
                                  {...register("location", {
                                    required: "location is required",
                                  })}
                                />
                              </InputGroup>
                              {errors.location && (
                                <span className="text-danger">
                                  {errors.location.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Days</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  min={0}
                                  type="text"
                                  name="days"
                                  placeholder="days .."
                                  className={classNames("", {
                                    "is-invalid": errors?.days,
                                  })}
                                  {...register("days", {
                                    required: "days is required",
                                  })}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === '-' || // Prevent negative sign
                                      e.key === '+' || // Prevent plus sign
                                      e.key === 'e' || // Prevent scientific notation
                                      e.key === 'E' || // Prevent scientific notation
                                      e.key === '.' || // Prevent decimal point (if only integers allowed)
                                      isNaN(Number(e.key)) && e.key !== 'Backspace' && e.key !== 'Tab' // Allow only numbers, Backspace, and Tab
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    const pasteData = e.clipboardData.getData('text');
                                    if (!/^\d+$/.test(pasteData)) { // Allow only numbers in pasted data
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </InputGroup>
                              {errors.days && (
                                <span className="text-danger">
                                  {errors.days.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">
                            <Form.Label className="text-left">Image</Form.Label>

                            <Form.Group>
                              <Form.Control
                                className={classNames("", {
                                  "is-invalid": errors?.image,
                                })}
                                type="file"
                                {...register("image", {
                                  required: "Image is required",
                                  validate: async (value) => {
                                    if (typeof value !== "string") {
                                      const fileTypes = ["jpg", "png", "jpeg"];
                                      const fileType = value[0].name?.split(".")[1];

                                      if (!fileTypes.includes(fileType)) {
                                        return `please upload a valid file format. (${fileTypes})`;
                                      }

                                      const sizes = await getDimension(value[0]);
                                      // if (
                                      //   sizes.width !== 1296 &&
                                      //   sizes.height !== 465
                                      // ) {
                                      //   return "Image width and height must be 1296 px and 465 px";
                                      // }

                                      // const fileSize = Math.round(
                                      //   value[0].size / 1024
                                      // );
                                      // if (fileSize > 500) {
                                      //   return "file size must be lower than 500kb";
                                      // }
                                    }
                                  },
                                })}
                                accept=".jpg, .jpeg, .png"
                              />
                            </Form.Group>
                            {errors.image && (
                              <span className="text-danger">
                                {errors.image.message}
                              </span>
                            )}
                          </Row>
                        </div>
                      </Col>

                      <Col className="main-form-section mt-3">
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Image Preview</Form.Label>

                            {imageFile && imageFile?.length > 0 && (
                              <div className="image-preview-container mt-3">
                                <img
                                  // src={URL.createObjectURL(getValues("image")[0])}
                                  src={URL?.createObjectURL(imageFile[0])}
                                  alt="Preview"
                                  className="image-preview"
                                  style={{ width: "200px", height: "200px" }}
                                />
                              </div>
                            )}
                          </Row>
                        </div>
                      </Col>


                      <Col lg={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">
                            {" "}
                            {/* Align to left */}
                            {/* description */}
                            <Col sm={12}>
                              <Form.Label className="text-center">
                                description
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="description" // Provide the field name
                                  control={control} // Pass the control object from useForm()
                                  rules={{
                                    required: "Description is required",
                                  }} // Validation rules
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={descriptionValue || ""}
                                      onBlur={(newContent) => {
                                        setValue("description", newContent);
                                        trigger("description");
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.description && (
                                <span className="text-danger">
                                  {errors.description.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>



                      <Col lg={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">

                            <Col sm={12}>
                              <Form.Label className="text-center">
                                Inclusion
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="inclusion" // Provide the field name
                                  control={control} // Pass the control object from useForm()
                                  rules={{
                                    required:
                                      "  inclusion is required",
                                  }} // Validation rules
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={featuresAndAminitiesValue || ""}
                                      onBlur={(newContent) => {
                                        setValue(
                                          "inclusion",
                                          newContent
                                        );
                                        trigger("inclusion");
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.inclusion && (
                                <span className="text-danger">
                                  {errors.inclusion.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">

                            <Col sm={12}>
                              <Form.Label className="text-center">
                                Exclusion
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="exclusion" // Provide the field name
                                  control={control} // Pass the control object from useForm()
                                  rules={{
                                    required:
                                      "  Exclusion is required",
                                  }} // Validation rules
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={termsAndConditionValue || ""}
                                      onBlur={(newContent) => {
                                        setValue(
                                          "exclusion",
                                          newContent
                                        );
                                        trigger("exclusion");
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.exclusion && (
                                <span className="text-danger">
                                  {errors.exclusion.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">

                            <Col sm={12}>
                              <Form.Label className="text-center">
                                Note And Disclaimers
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="note_and_disclaimers" // Provide the field name
                                  control={control} // Pass the control object from useForm()
                                  rules={{
                                    required:
                                      "Note And Disclaimers is required",
                                  }} // Validation rules
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={note_and_disclaimers || ""}
                                      onBlur={(newContent) => {
                                        setValue(
                                          "note_and_disclaimers",
                                          newContent
                                        );
                                        trigger("note_and_disclaimers");
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.note_and_disclaimers && (
                                <span className="text-danger">
                                  {errors.note_and_disclaimers.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>



                      <div className="main-form-section mt-5"></div>
                      <Card.Title>
                        Packages day
                        {quantityError && (
                          <div className="text-danger">{quantityError}</div>
                        )}
                      </Card.Title>
                      <hr />

                      {dayFields.map((variant, index) => (
                        <div
                          key={variant.id}
                          className="main-form-section mt-3"
                        >
                          <Row>
                            <Col md={6}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-center">
                                  <Form.Label>Name</Form.Label>
                                  <Form.Group>
                                    <InputGroup>
                                      <Form.Control

                                        type="text"
                                        name={`packages_day.${index}.name`}
                                        placeholder="Name"
                                        className={classNames("", {
                                          "is-invalid":
                                            errors?.packages_day?.[index]?.name,
                                        })}
                                        {...register(`packages_day.${index}.name`, {
                                          required: "Name is required",
                                        })}
                                      />
                                    </InputGroup>
                                    {errors?.packages_day?.[index]?.name && (
                                      <span className="text-danger">
                                        {errors?.packages_day?.[index]?.name.message}
                                      </span>
                                    )}
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-start">
                                  <Col sm={12}>
                                    <Form.Label className="text-center">Description</Form.Label>
                                    <Form.Group>
                                      <Controller
                                        name={`packages_day.${index}.description`}
                                        control={control}
                                        rules={{
                                          required: "Description is required",
                                        }}
                                        render={({ field }) => (
                                          <JoditEditor
                                            value={field.value || ""}
                                            onBlur={(newContent) => {
                                              setValue(`packages_day.${index}.description`, newContent);
                                              trigger(`packages_day.${index}.description`);
                                            }}
                                          />
                                        )}
                                      />
                                    </Form.Group>
                                    {errors?.packages_day?.[index]?.description && (
                                      <span className="text-danger">
                                        {errors?.packages_day?.[index]?.description.message}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </Col>



                            <Col lg={3}>
                              <button
                                className="mt-3 add-varient"
                                type="button"
                                onClick={() => removeDay(index)}
                              >
                                Remove Day
                              </button>
                            </Col>
                          </Row>
                        </div>
                      ))}

                      <div className="main-form-section mt-3"></div>
                      <hr />
                      <div className="text-center">
                        <button
                          type="button"
                          className="btn btn-primary mb-3"
                          onClick={() => appendDay({})}
                        >
                          + Add Day
                        </button>
                      </div>

                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name={"cancel"}
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <Button
                            name={"save"}
                            onClick={handleSubmit(onSubmit)}
                            type="button"
                            className="btn btn-primary mb-3"
                          >
                            <FontAwesomeIcon
                              icon="fa-solid fa-floppy-disk"
                              className="me-2"
                            />
                            save
                          </Button>

                          {/* <Button
                            name={"next"}
                            type="button"
                            className="save-btnnnnnn me-2"
                          >
                            <FontAwesomeIcon
                              icon="fa-solid fa-floppy-disk"
                              className="me-2"
                            />
                            Next
                          </Button> */}
                        </div>
                      </Row>

                      <hr />
                      {/* <MultiVarientMain /> */}
                    </Row>
                  </Form>
                </Container>
              </Card.Body>
            </Card>
          </Offcanvas.Body>
        </Offcanvas>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </div>
    </>
  );
};

export default AddOffCanvance;
